module.exports = __webpack_public_path__ + "img/user_icon.4801a18b.svg";